import { Params } from '@angular/router';

import { ParentCheersQueryParams } from './models/parent-cheers-query-params';
import { SubscriptionSource } from './models/subscription-source';

export const PARENT_ROUTE = {
  name: 'parent',
  route(): string[] {
    return ['/', this.name];
  },
  DEFAULT: '',

  PASSWORD_CREATOR: {
    name: 'createpassword/:token',
    route(): string[] {
      return [];
    }
  },

  LOGGED: {
    name: ':studentId/:classId',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.route(), studentId, classId];
    }
  },

  CHEER_SENT: {
    name: 'cheersent',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    },
    queryParams(branchId: string): Params {
      return {
        branchId: encodeURI(branchId)
      };
    }
  },

  CHEER_SENT_SUBSCRIBED: {
    name: 'cheersentsubscribed',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    },
    queryParams(branchId: string): Params {
      return {
        branchId: encodeURI(branchId)
      };
    }
  },

  SETTINGS: {
    name: 'settings',
    route(): string[] {
      return [...PARENT_ROUTE.route(), this.name];
    }
  },
  SUBSCRIPTION: {
    name: 'subscription',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },

  SUBSCRIPTION_EXISTING_CHILD: {
    name: 'childsubscription',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    },
    queryParams(source: SubscriptionSource): Params {
      return {
        source: source
      };
    }
  },

  SUBSCRIPTION_ADD_CHILD: {
    name: 'region/:countryCode/:regionCode/subscriptionaddchild',
    queryParams(courseId?: string): Params {
      return {
        courseId: courseId ? encodeURI(courseId) : null
      };
    },
    route(countryCode: string, regionCode: string): string[] {
      return [...PARENT_ROUTE.route(), 'region', countryCode, regionCode, 'subscriptionaddchild'];
    }
  },

  CONFIRM_SUBSCRIPTION_CANCELLATION: {
    name: 'confirmsubscriptioncancellation',
    queryParams(subscriptionId: string, nextPaymentDate: any, orderDate: any, frequency: string): Params {
      return {
        frequency: encodeURI(frequency),
        nextPaymentDate: encodeURI(nextPaymentDate),
        orderDate: encodeURI(orderDate),
        subscriptionId: encodeURI(subscriptionId)
      };
    },
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },

  JOURNEY: {
    name: 'journey',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },

  PROFILE: {
    name: 'profile',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },

  HELP_CENTER: {
    name: 'helpcenter',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },

  RESET_CHILD_PASSWORD: {
    name: 'resetchildpassword',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },

  CLASS_OS_PRO: {
    name: 'class-os-pro',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },

  ALL_CHEERS: {
    name: 'allcheers',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },
  GROWTHMINDSET: {
    name: 'growthmindset',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },
  CHEERS: {
    name: 'cheers',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    },
    queryParams(params: ParentCheersQueryParams): Params {
      return {
        branchid: params.branchId ? encodeURI(params.branchId) : null,
        milestonescount: params.milestonesCount ? encodeURI(params.milestonesCount.toString()) : null,
        usertype: params.userType ? encodeURI(params.userType) : null
      };
    }
  },

  WELCOME_ABOARD: {
    name: 'welcomeaboard',
    route(): string[] {
      return [...PARENT_ROUTE.route(), this.name];
    }
  },

  REGISTER: {
    name: 'register',
    route(): string[] {
      return [...PARENT_ROUTE.route(), this.name];
    },
    queryParams(studentId: string, classId: string): Params {
      return {
        studentId: studentId,
        classId: classId
      };
    }
  },

  WORKSHOPS: {
    name: 'workshops',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },

  WORKSHOP_DETAILS: {
    name: 'workshop/:workshopId',
    route(studentId: string, classId: string, workshopId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), 'workshop', workshopId];
    }
  },

  ADVANCED_PARENTAL_CONTROLS: {
    name: 'game-parental-controls',
    noStudentRoute(): string[] {
      return [PARENT_ROUTE.name, this.name];
    },
    queryParams(gameId: string): Params {
      return {
        gameId
      };
    },
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },
  GAME_OPT_IN: {
    name: 'game-opt-in',
    route(studentId: string, classId: string): string[] {
      return [...PARENT_ROUTE.LOGGED.route(studentId, classId), this.name];
    }
  },
  CREATE_ACCOUNT: {
    name: 'createaccount',
    queryParams(ParentRequestId: string): Params {
      return {
        ParentRequestId
      };
    },
    route(): string[] {
      return [...PARENT_ROUTE.route(), this.name];
    }
  },
  SELECT_COURSE: {
    name: 'selectcourse',
    route(): string[] {
      return [...PARENT_ROUTE.route(), this.name];
    }
  }
};
